
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.82 19.539V10.75H.498V7.585h2.324V4.882C2.82 2.76 4.194.808 7.357.808c1.28 0 2.228.123 2.228.123L9.51 3.886s-.965-.01-2.02-.01c-1.14 0-1.323.526-1.323 1.399v2.31h3.434l-.15 3.165H6.168v8.789H2.821z","fill":"#fff"}})])
          )
        }
      }
    